/** Shared palette for stacked / multi-series charts (cost methods, tenants, etc.). */
export const CHART_COLORS = [
  '#2563eb',
  '#0d9488',
  '#ca8a04',
  '#ea580c',
  '#059669',
  '#64748b',
  '#0891b2',
  '#db2777',
  '#7c3aed',
  '#dc2626',
  '#16a34a',
  '#9333ea',
] as const;

export function chartColorAt(index: number): string {
  return CHART_COLORS[index % CHART_COLORS.length];
}
